import { render, staticRenderFns } from "./AutoPurchaseTemplate.vue?vue&type=template&id=9d669d90&"
import script from "./AutoPurchaseTemplate.vue?vue&type=script&lang=js&"
export * from "./AutoPurchaseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports